// Tabela simplificada (data + fornecedor + descrição + valor) usada nas
// listas de divergência da reconciliação CA × XLSX / Notion × CA.
import { Table, Typography } from 'antd';

const { Text } = Typography;

interface Props {
  itens: any[];
  fmt: (v: any) => string;
}

export default function ListaSimples({ itens, fmt }: Props) {
  return (
    <Table
      size="small" pagination={false} rowKey={(_, i) => i!}
      dataSource={itens}
      columns={[
        { title: 'Data', dataIndex: 'data_competencia', key: 'd', render: (_, r: any) => String(r.data_competencia || r.data || '').slice(0, 10) },
        { title: 'Fornecedor', dataIndex: 'fornecedor', key: 'f', render: (_, r: any) => r.fornecedor || r.fornecedor_original || '—' },
        { title: 'Descrição', dataIndex: 'descricao', key: 'desc', ellipsis: true, render: (_, r: any) => r.descricao || r.motivo || '—' },
        {
          title: 'Valor', dataIndex: 'valor', key: 'v', align: 'right',
          render: (v: any) => <Text style={{ color: '#B91626' }}>{fmt(Math.abs(parseFloat(v || 0)))}</Text>,
        },
      ]}
    />
  );
}
